import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class QualificationDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Qualification Id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  qualificationId: number;
  @ApiProperty()
  @IsNotEmpty({message: "Qualification Name should not be empty "})
  qualificationName: string;
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only aplphabets" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only alphabets" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}